export function currentFiscalYear () {
  let today = new Date();
	return today.getMonth() >= 8
    ? today.getFullYear()
    : today.getFullYear() - 1
}



// WEBPACK FOOTER //
// ./src/helpers/fiscalYear.js